import Label from 'components/form/Label/Label';
import {
  BureauReport,
  GettingNewCard,
  OpenAccountToday,
  OpeningNewCreditCard,
  SeeDetails,
} from 'partial/OfferManager/modules/PotentialScoreFactorsModule/PotentialCreditFactorsTipsLinks';

const PotentialCreditFactorsTips = props => {
  const {
    grade,
    selectedPotentialFactor,
    handleClickInFactor,
    factor,
    seenOfferModulePosition,
    handleClickOpeningNewCreditCard,
    handleClickBereauReport,
    handleClickGettingNewCard,
    handleClickOpenAccountToday,
  } = props;

  const textOldesTradeLineToCreditAge = factor?.oldestTradeLine?.creditor
    ? `(${factor?.oldestTradeLine?.creditor}) `
    : '';

  const currentUsageOverSuggested = factor?.currentUsageOverSuggested ?? '0';

  const CreditFactorTips = {
    PAYMENT_HISTORY: {
      A: (
        <Label>
          Your payment history is exceptional. On-time payments are important
          for the continuous growth of your credit.{' '}
          <SeeDetails
            selectedPotentialFactor={selectedPotentialFactor}
            handleClickInFactor={handleClickInFactor}
            seenOfferModulePosition={seenOfferModulePosition}
          />
        </Label>
      ),
      B: (
        <Label>
          On time payments are very important. Pay down your{' '}
          {factor?.delinquentTradelineCount} past due accounts as soon as
          possible. Set up automatic bill payment to ensure you do not miss due
          dates. Check negative marks on your{' '}
          <BureauReport handleClickBereauReport={handleClickBereauReport} /> and
          dispute errors directly with the bureaus.{' '}
          <SeeDetails
            selectedPotentialFactor={selectedPotentialFactor}
            handleClickInFactor={handleClickInFactor}
            seenOfferModulePosition={seenOfferModulePosition}
          />
        </Label>
      ),
      C: (
        <Label>
          Negative marks can stay on your credit report for 7-10 years. Take
          steps to fix your {factor?.derogatoryTradelineCount} derogatory
          accounts as soon as possible. Check negative marks on your{' '}
          <BureauReport handleClickBereauReport={handleClickBereauReport} /> and
          dispute errors directly with the bureaus.{' '}
          <SeeDetails
            selectedPotentialFactor={selectedPotentialFactor}
            handleClickInFactor={handleClickInFactor}
            seenOfferModulePosition={seenOfferModulePosition}
          />
        </Label>
      ),
      D: (
        <Label>
          On time payments are very important. Pay down your{' '}
          {factor?.delinquentTradelineCount} past due accounts and take steps to
          fix your {factor?.derogatoryTradelineCount} derogatory accounts as
          soon as possible. Check negative marks on your{' '}
          <BureauReport handleClickBereauReport={handleClickBereauReport} /> and
          dispute errors directly with the bureaus.{' '}
          <SeeDetails
            selectedPotentialFactor={selectedPotentialFactor}
            handleClickInFactor={handleClickInFactor}
            seenOfferModulePosition={seenOfferModulePosition}
          />
        </Label>
      ),
      F: (
        <Label>
          On time payments are very important. Pay down your{' '}
          {factor?.delinquentTradelineCount} past due accounts and take steps to
          fix your {factor?.derogatoryTradelineCount} derogatory accounts as
          soon as possible. Check negative marks on your{' '}
          <BureauReport handleClickBereauReport={handleClickBereauReport} /> and
          dispute errors directly with the bureaus.{' '}
          <SeeDetails
            selectedPotentialFactor={selectedPotentialFactor}
            handleClickInFactor={handleClickInFactor}
            seenOfferModulePosition={seenOfferModulePosition}
          />
        </Label>
      ),
      DEFAULT: (
        <Label>
          You have no payment history. Lenders like to see a record of on-time
          payments on credit accounts. Open a new account and arrange the
          payment due date to be just after your pay is deposited in your bank
          account.{' '}
          <SeeDetails
            selectedPotentialFactor={selectedPotentialFactor}
            handleClickInFactor={handleClickInFactor}
            seenOfferModulePosition={seenOfferModulePosition}
          />
        </Label>
      ),
    },
    CREDIT_USAGE: {
      A: (
        <Label>
          Your credit usage is excellent at 0. Keep it below 10% to maintain
          your A grade.{' '}
          <SeeDetails
            selectedPotentialFactor={selectedPotentialFactor}
            handleClickInFactor={handleClickInFactor}
            seenOfferModulePosition={seenOfferModulePosition}
          />
        </Label>
      ),
      B: (
        <Label>
          If possible reduce your total credit usage to 10% by making a payment
          or payments totaling at least ${currentUsageOverSuggested}.{' '}
          <OpeningNewCreditCard
            handleClickOpeningNewCreditCard={handleClickOpeningNewCreditCard}
          />{' '}
          also increases your credit limit and so reduces your credit usage.{' '}
          <SeeDetails
            selectedPotentialFactor={selectedPotentialFactor}
            handleClickInFactor={handleClickInFactor}
            seenOfferModulePosition={seenOfferModulePosition}
          />
        </Label>
      ),
      C: (
        <Label>
          If possible reduce your total credit usage to 30% by making a payment
          or payments totaling at least ${currentUsageOverSuggested}.{' '}
          <OpeningNewCreditCard
            handleClickOpeningNewCreditCard={handleClickOpeningNewCreditCard}
          />{' '}
          also increases your credit limit and so reduces your credit usage.{' '}
          <SeeDetails
            selectedPotentialFactor={selectedPotentialFactor}
            handleClickInFactor={handleClickInFactor}
            seenOfferModulePosition={seenOfferModulePosition}
          />
        </Label>
      ),
      D: (
        <Label>
          If possible reduce your total credit usage to 50% by making a payment
          or payments totaling at least ${currentUsageOverSuggested}.{' '}
          <OpeningNewCreditCard
            handleClickOpeningNewCreditCard={handleClickOpeningNewCreditCard}
          />{' '}
          also increases your credit limit and so reduces your credit usage.{' '}
          <SeeDetails
            selectedPotentialFactor={selectedPotentialFactor}
            handleClickInFactor={handleClickInFactor}
            seenOfferModulePosition={seenOfferModulePosition}
          />
        </Label>
      ),
      F: (
        <Label>
          If possible reduce your total credit usage to 70% by making a payment
          or payments totaling at least ${currentUsageOverSuggested}.{' '}
          <OpeningNewCreditCard
            handleClickOpeningNewCreditCard={handleClickOpeningNewCreditCard}
          />{' '}
          also increases your credit limit and so reduces your credit usage.{' '}
          <SeeDetails
            selectedPotentialFactor={selectedPotentialFactor}
            handleClickInFactor={handleClickInFactor}
            seenOfferModulePosition={seenOfferModulePosition}
          />
        </Label>
      ),
      DEFAULT: (
        <Label>
          You have zero credit usage. Credit usage is an important factor in
          building your score. When you{' '}
          <OpeningNewCreditCard
            handleClickOpeningNewCreditCard={handleClickOpeningNewCreditCard}
            noCreditUsage
          />{' '}
          keep your balance under 30% of your credit limit.{' '}
          <SeeDetails
            selectedPotentialFactor={selectedPotentialFactor}
            handleClickInFactor={handleClickInFactor}
            seenOfferModulePosition={seenOfferModulePosition}
          />
        </Label>
      ),
    },
    CREDIT_AGE: {
      A: (
        <Label>
          Your credit age is excellent and an important factor in your credit
          score. Keep old accounts open to build credit age even if you plan on{' '}
          <GettingNewCard
            handleClickGettingNewCard={handleClickGettingNewCard}
          />
          .{' '}
          <SeeDetails
            selectedPotentialFactor={selectedPotentialFactor}
            handleClickInFactor={handleClickInFactor}
            seenOfferModulePosition={seenOfferModulePosition}
          />
        </Label>
      ),
      B: (
        <Label>
          You are making progress. Credit age is an important factor in your
          credit score. Keep old accounts open to build credit age even if you
          plan on{' '}
          <GettingNewCard
            handleClickGettingNewCard={handleClickGettingNewCard}
          />
          .{' '}
          <SeeDetails
            selectedPotentialFactor={selectedPotentialFactor}
            handleClickInFactor={handleClickInFactor}
            seenOfferModulePosition={seenOfferModulePosition}
          />
        </Label>
      ),
      C_F_MORE1YEAR: (
        <Label>
          Your credit history is fairly recent with an average account age of
          1-2 years. Keep your oldest credit card account{' '}
          {textOldesTradeLineToCreditAge}
          open and in good standing to build credit history.{' '}
          <SeeDetails
            selectedPotentialFactor={selectedPotentialFactor}
            handleClickInFactor={handleClickInFactor}
            seenOfferModulePosition={seenOfferModulePosition}
          />
        </Label>
      ),
      C_F: (
        <Label>
          Your credit history is fairly recent with an average account age of
          less than a year. Keep your oldest credit card account{' '}
          {textOldesTradeLineToCreditAge} open and in good standing to build
          credit history.{' '}
          <SeeDetails
            selectedPotentialFactor={selectedPotentialFactor}
            handleClickInFactor={handleClickInFactor}
            seenOfferModulePosition={seenOfferModulePosition}
          />
        </Label>
      ),
      DEFAULT: <Label></Label>,
    },
    ACCOUNT_MIX: {
      A: (
        <Label>
          You have an excellent mix of credit types. This helps your credit
          score and is looked on favorably by lenders.{' '}
          <SeeDetails
            selectedPotentialFactor={selectedPotentialFactor}
            handleClickInFactor={handleClickInFactor}
            seenOfferModulePosition={seenOfferModulePosition}
          />
        </Label>
      ),
      B: (
        <Label>
          A more diverse mix of credit accounts may help your credit score.
          Lenders like to see a range of credit type for example, credit card,
          auto loan, home loan.{' '}
          <SeeDetails
            selectedPotentialFactor={selectedPotentialFactor}
            handleClickInFactor={handleClickInFactor}
            seenOfferModulePosition={seenOfferModulePosition}
          />
        </Label>
      ),
      C: (
        <Label>
          A more diverse mix of around 6 credit accounts is likely to help your
          credit score. Lenders prefer to see a range of credit type for
          example, credit card, auto loan, home loan.{' '}
          <SeeDetails
            selectedPotentialFactor={selectedPotentialFactor}
            handleClickInFactor={handleClickInFactor}
            seenOfferModulePosition={seenOfferModulePosition}
          />
        </Label>
      ),
      D: (
        <Label>
          A more diverse mix of around 6 credit accounts is likely to help your
          credit score. Lenders prefer to see a range of credit type for
          example, credit card, auto loan, home loan.{' '}
          <SeeDetails
            selectedPotentialFactor={selectedPotentialFactor}
            handleClickInFactor={handleClickInFactor}
            seenOfferModulePosition={seenOfferModulePosition}
          />
        </Label>
      ),
      F: (
        <Label>
          Lenders prefer to see a diverse mix of credit types for example,
          credit card, auto loan, home loan.{' '}
          <OpenAccountToday
            handleClickOpenAccountToday={handleClickOpenAccountToday}
          />{' '}
          to improve your account mix.{' '}
          <SeeDetails
            selectedPotentialFactor={selectedPotentialFactor}
            handleClickInFactor={handleClickInFactor}
            seenOfferModulePosition={seenOfferModulePosition}
          />
        </Label>
      ),
      DEFAULT: <Label></Label>,
    },
    CREDIT_INQUIRIES: {
      A: (
        <Label>
          Your credit inquiries are low. This is excellent. Remember to apply
          for cards one at a time and not all at once.{' '}
          <SeeDetails
            selectedPotentialFactor={selectedPotentialFactor}
            handleClickInFactor={handleClickInFactor}
            seenOfferModulePosition={seenOfferModulePosition}
            ctaText="See more recent credit details"
          />
        </Label>
      ),
      B: (
        <Label>
          Every credit inquiry affects your score. Remember to apply for cards
          one at a time and not all at once.{' '}
          <SeeDetails
            selectedPotentialFactor={selectedPotentialFactor}
            handleClickInFactor={handleClickInFactor}
            seenOfferModulePosition={seenOfferModulePosition}
            ctaText="See more recent credit details"
          />
        </Label>
      ),
      C_F: (
        <Label>
          Each lender credit inquiry known as hard inquiries may lower your
          score by 5-10 points. Soft inquiries, such as a background check, do
          not affect your score.{' '}
          <SeeDetails
            selectedPotentialFactor={selectedPotentialFactor}
            handleClickInFactor={handleClickInFactor}
            seenOfferModulePosition={seenOfferModulePosition}
            ctaText="See more recent credit details"
          />
        </Label>
      ),
      DEFAULT: (
        <Label>
          No hard inquiries were found in your credit report.
          <SeeDetails
            selectedPotentialFactor={selectedPotentialFactor}
            handleClickInFactor={handleClickInFactor}
            seenOfferModulePosition={seenOfferModulePosition}
            ctaText="See more recent credit details"
          />
        </Label>
      ),
    },
  };

  return (
    <Label type={'Body-2'}>
      {CreditFactorTips?.[selectedPotentialFactor]?.[grade || 'DEFAULT']}
    </Label>
  );
};

export default PotentialCreditFactorsTips;
